import { TrendingUp } from 'lucide-react'
import BrechasList from './brechas/BrechasList'

const CriterioPanel = ({ criterio, criterioId }) => {
  return (
    <div className="space-y-6">
      {/* Header del Criterio */}
      <div className="card">
        <div className="flex items-start space-x-3 mb-4">
          <div className="flex-shrink-0">
            <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center">
              <TrendingUp className="h-6 w-6 text-purple-600" />
            </div>
          </div>
          <div className="flex-1">
            <h2 className="text-2xl font-bold text-gray-900 mb-1">
              {criterio?.nombre || `Criterio ${criterioId}`}
            </h2>
            <p className="text-sm text-gray-600">
              Gestión de Mejora Continua - Brechas y Ciclos PDCA
            </p>
            {criterio?.dimension && (
              <p className="text-xs text-gray-500 mt-1">
                {criterio.dimension}
              </p>
            )}
          </div>
        </div>

        <div className="bg-blue-50 border-l-4 border-blue-400 p-4 rounded">
          <p className="text-sm text-blue-800">
            <strong>💡 Nota:</strong> Las evidencias de cumplimiento se gestionan en la pestaña "Subir Evidencia". 
            Aquí solo gestionas las <strong>brechas detectadas</strong> y sus <strong>ciclos de mejora PDCA</strong>.
          </p>
        </div>
      </div>

      {/* Contenido: Lista de Brechas */}
      <BrechasList criterioId={criterioId} />
    </div>
  )
}

export default CriterioPanel
